export type InstagramOutreachAvailability = 'COMPOSIO' | 'COMING_SOON' | 'UNKNOWN';

export function parseInstagramOutreachAvailability(value: unknown): InstagramOutreachAvailability {
  return value === 'COMPOSIO' || value === 'COMING_SOON' ? value : 'UNKNOWN';
}

export function parseOutreachAvailability(value: unknown): { instagram: InstagramOutreachAvailability } {
  return {
    instagram: parseInstagramOutreachAvailability(value && typeof value === 'object' ? (value as Record<string, unknown>).instagram : undefined),
  };
}

/** Carry a fresh capability alongside a partial failure while React Query retains the previous credential rows. */
export class ConnectorStatusReadError extends Error {
  constructor(message: string, readonly outreachAvailability: { instagram: InstagramOutreachAvailability }) {
    super(message);
  }
}

export function instagramOutreachAvailability(
  response: { outreachAvailability?: unknown } | undefined,
  error?: unknown,
): InstagramOutreachAvailability {
  if (error) {
    return error instanceof ConnectorStatusReadError ? error.outreachAvailability.instagram : 'UNKNOWN';
  }
  return parseOutreachAvailability(response?.outreachAvailability).instagram;
}
